import script from "./OsEventosEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OsEventosEditPage.vue?vue&type=script&setup=true&lang=js"

import "./OsEventosEditPage.vue?vue&type=style&index=0&id=1ae28578&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ae28578"]])

export default __exports__